import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.flat-map.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.some.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "flex flex-col !border-surface-100 pb-3.5 px-3.5 gap-2"
};
const _hoisted_2 = {
  key: 0,
  class: "pt-3.5"
};
const _hoisted_3 = {
  key: 1
};
const _hoisted_4 = {
  class: "text-center text-sm text-surface-300 dark:text-surface-950 my-10"
};
const _hoisted_5 = {
  key: 2
};
const _hoisted_6 = {
  class: "flex flex-row gap-2 pt-3.5 pl-2"
};
const _hoisted_7 = {
  class: "font-medium uppercase text-surface-400 text-sm"
};
const _hoisted_8 = ["onClick"];
const _hoisted_9 = {
  class: "flex flex-col gap-1"
};
const _hoisted_10 = {
  class: "text-sm font-semibold text-surface-900"
};
const _hoisted_11 = {
  class: "text-sm"
};
const _hoisted_12 = {
  class: "flex flex-col justify-center align-middle content-center ml-auto min-w-8"
};
const _hoisted_13 = {
  key: 0,
  class: "text-xxl fa-regular fa-arrow-turn-down-left text-primary-500"
};
const _hoisted_14 = {
  key: 1,
  class: "flex flex-col !border-surface-100 pb-3.5 px-3.5 gap-2"
};
const _hoisted_15 = {
  class: "flex flex-col gap-2"
};
const _hoisted_16 = {
  class: "flex flex-row gap-2"
};
const _hoisted_17 = {
  class: "font-medium uppercase text-surface-400 dark:text-surface-950 pl-2 text-sm"
};
const _hoisted_18 = {
  key: 0,
  class: "flex flex-col"
};
const _hoisted_19 = ["onClick"];
const _hoisted_20 = {
  class: "flex flex-col justify-center items-end w-[10%]"
};
const _hoisted_21 = ["onClick"];
const _hoisted_22 = {
  key: 1
};
const _hoisted_23 = {
  class: "text-center text-sm text-surface-300 dark:text-surface-950"
};
const _hoisted_24 = {
  key: 0,
  class: "flex flex-row gap-5 p-3.5 !text-surface-600 justify-end"
};
const _hoisted_25 = {
  class: "flex flex-row gap-2 items-center"
};
const _hoisted_26 = {
  class: "text-color dark:text-surface-950 text-sm"
};
const _hoisted_27 = {
  class: "flex flex-row gap-2 items-center"
};
const _hoisted_28 = {
  class: "text-color dark:text-surface-950 text-sm"
};
const _hoisted_29 = {
  class: "flex flex-row gap-2 items-center"
};
const _hoisted_30 = {
  class: "flex flex-col gap-1 justify-center align-middle content-center"
};
const _hoisted_31 = {
  class: "p-1.5 bg-surface-100 text-surface-500 rounded text-sm"
};
const _hoisted_32 = {
  class: "text-color dark:text-surface-950 text-sm"
};
import { useStore } from "vuex";
import { ref, onMounted, onUnmounted, watch, computed } from "vue";
import { useRouter } from "vue-router";
import { useDebounceFn } from "@vueuse/core";
import network from "@/utils/network";
import { localFetch, tenantIdFromPath } from "@/utils/util";
import { PRIVILEGES } from "@/utils/const";
const regularSearchPrivileges = "meili.search.profile,meili.search.time_off,meili.search.sitemap";
const elevatedSearchPrivileges = "meili.search.profile,meili.search.time_off,meili.search.resource,meili.search.competency,meili.search.logged_time,meili.search.sitemap,meili.search.project";
export default {
  __name: 'CommandKSearch',
  setup(__props) {
    const store = useStore();
    const userId = computed(() => store.getters["session/userId"]);
    const router = useRouter();
    const axios = network.createAxiosInstance();
    const query = ref("");
    const querying = ref(false);
    const searchVisible = ref(false);
    const searchResults = ref([]);
    const recents = ref([]);
    const selectedIndex = ref(-1);
    const navigateTo = url => {
      if (url) {
        router.push(url);
        searchVisible.value = false;
        query.value = "";
        selectedIndex.value = -1;
      }
    };
    const isSelected = result => {
      const flatResults = searchResults.value.flatMap(c => c.results);
      return flatResults.indexOf(result) === selectedIndex.value;
    };
    const fetchRecents = async () => {
      let recentCall = await axios.get(`/meili/recent`, {
        headers: {
          "X-Tenant-Key": tenantIdFromPath(),
          "X-User-Id": userId.value
        }
      });
      recents.value = recentCall.data;
    };
    const deleteRecent = async recentId => {
      await axios.delete(`/meili/recent?recent_id=${recentId}`, {
        headers: {
          "X-Tenant-Key": tenantIdFromPath()
        }
      });
      recents.value = recents.value.filter(recent => recent.id !== recentId);
    };
    const selectRecentQuery = async recentId => {
      query.value = recents.value.find(recent => recent.id === recentId).query;
    };
    const activateSearch = () => {
      query.value = "";
      searchVisible.value = !searchVisible.value;
    };
    const toggleSearch = event => {
      if ((event.metaKey || event.ctrlKey) && event.key === "k") {
        event.preventDefault();
        activateSearch();
      } else if (event.key === "Escape" && searchVisible.value) {
        searchVisible.value = false;
        query.value = "";
        selectedIndex.value = -1;
        searchResults.value = [];
        recents.value = [];
        querying.value = false;
      }
    };
    const handleResults = hits => {
      const categories = [];
      hits.sort((a, b) => b._federation.weightedRankingScore - a._federation.weightedRankingScore);
      categories.push({
        top: true,
        label: "meili.category.top",
        results: hits.slice(0, 5)
      });
      hits.slice(5).forEach(hit => {
        const category = categories.find(c => c.label === hit.category);
        if (!category) {
          categories.push({
            label: hit.category,
            results: [hit]
          });
        } else {
          category.results.push(hit);
        }
      });
      return categories;
    };
    const performSearch = async () => {
      if (query.value.trim().length >= 3) {
        try {
          querying.value = true;
          searchResults.value = [];
          const response = await queryMeiliSearch();
          await fetchRecents();
          searchResults.value = handleResults(response.data.hits);
          querying.value = false;
        } catch (error) {
          console.error("Search failed:", error);
          querying.value = false;
        }
      } else {
        searchResults.value = [];
        querying.value = false;
      }
    };
    const debouncedSearch = useDebounceFn(performSearch, 300);
    const userPrivileges = computed(() => {
      return store.getters["session/hasAnyAuthority"](PRIVILEGES.ENTERPRISE.PROJECT.CREATE, PRIVILEGES.ENTERPRISE.PROJECT.ADMIN) ? elevatedSearchPrivileges : regularSearchPrivileges;
    });
    const queryMeiliSearch = async () => {
      return await axios.get(`/meili/search/${query.value.trim()}`, {
        headers: {
          "X-Tenant-Key": tenantIdFromPath(),
          "X-User-Id": userId.value,
          "X-User-Privileges": userPrivileges.value,
          //TODO: TEMPORARY, super-unsafe
          "X-Language-Code": localFetch("stored_locale") ?? "hu"
        }
      });
    };
    const searchNavigationHandler = event => {
      if (!searchVisible.value) return;
      const flatResults = searchResults.value.flatMap(c => c.results);
      const maxIndex = flatResults.length - 1;
      switch (event.key) {
        case "ArrowDown":
          event.preventDefault();
          selectedIndex.value = Math.min(selectedIndex.value + 1, maxIndex);
          break;
        case "ArrowUp":
          event.preventDefault();
          selectedIndex.value = Math.max(selectedIndex.value - 1, 0);
          break;
        case "Enter":
          event.preventDefault();
          if (selectedIndex.value >= 0 && selectedIndex.value <= maxIndex) {
            navigateTo(flatResults[selectedIndex.value].url);
          }
          break;
      }
    };
    const isDialogFooterVisible = computed(() => {
      return !querying.value && hasAnyResults.value;
    });
    const hasAnyResults = computed(() => {
      return searchResults.value.some(c => c.results.length > 0);
    });
    const cleanSearch = () => {
      selectedIndex.value = -1;
      searchResults.value = [];
    };
    watch(query, async newValue => {
      if (newValue.trim().length >= 3) {
        cleanSearch();
        querying.value = true;
        debouncedSearch();
      } else {
        cleanSearch();
        searchResults.value = [];
      }
      if (newValue.trim().length === 0) {
        await fetchRecents();
      }
    });
    watch([query, searchVisible], () => {
      selectedIndex.value = -1;
    });
    onMounted(async () => {
      window.addEventListener("keydown", toggleSearch);
      window.addEventListener("keydown", searchNavigationHandler);
      await fetchRecents();
    });
    onUnmounted(() => {
      window.removeEventListener("keydown", toggleSearch);
      window.removeEventListener("keydown", searchNavigationHandler);
    });
    return (_ctx, _cache) => {
      const _component_Button = _resolveComponent("Button");
      const _component_InputIcon = _resolveComponent("InputIcon");
      const _component_InputText = _resolveComponent("InputText");
      const _component_IconField = _resolveComponent("IconField");
      const _component_Skeleton = _resolveComponent("Skeleton");
      const _component_Dialog = _resolveComponent("Dialog");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_Button, {
        icon: "fa-regular fa-magnifying-glass",
        variant: "text",
        severity: "contrast",
        "aria-haspopup": "true",
        "aria-controls": "icon_menu",
        onClick: activateSearch,
        size: "small",
        pt: {
          root: {
            class: 'hover:!bg-surface-100'
          },
          icon: {
            class: '!text-surface-700'
          }
        }
      }), _createVNode(_component_Dialog, {
        visible: searchVisible.value,
        "onUpdate:visible": _cache[1] || (_cache[1] = $event => searchVisible.value = $event),
        modal: "",
        header: "Search",
        class: "w-[90vw] md:w-[45vw]",
        closable: false,
        draggable: false,
        dismissableMask: "",
        pt: {
          root: {
            class: '!bg-surface-0 !border-0 dark:!border',
            style: {
              '--p-dialog-border-color': 'var(--p-surface-100)'
            }
          },
          mask: {
            class: 'dark:!bg-[#000000e6]'
          },
          content: {
            class: 'p-0'
          },
          footer: {
            class: ['p-0', {
              '!border-t dark:!border-t-surface-100': isDialogFooterVisible.value
            }]
          },
          header: {
            class: ['p-0', {
              '!border-b dark:!border-b-surface-100': querying.value || hasAnyResults.value || query.value.length >= 3
            }]
          }
        }
      }, {
        header: _withCtx(() => [_createVNode(_component_IconField, {
          class: "w-full p-3 relative"
        }, {
          default: _withCtx(() => [_createVNode(_component_InputIcon, {
            class: "fa-regular fa-magnifying-glass pl-2.5 !text-surface-400"
          }), _createVNode(_component_InputText, {
            modelValue: query.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => query.value = $event),
            placeholder: _ctx.$tf('search.commandK.placeholder'),
            autofocus: "",
            class: "w-full",
            pt: {
              root: {
                class: '!border-0 !shadow-none !bg-surface-0 !border-surface-200 !text-surface-400 !shadow-none !text-[1.188rem] !pl-10',
                style: {
                  '--p-inputtext-placeholder-color': 'var(--p-surface-400)'
                }
              }
            }
          }, null, 8, ["modelValue", "placeholder"]), _cache[2] || (_cache[2] = _createElementVNode("div", {
            class: "absolute right-5 top-[1.375rem] bottom-0 flex items-center justify-center gap-0.5 p-1 bg-surface-100 rounded border border-surface-200 h-6"
          }, [_createElementVNode("kbd", {
            class: "text-surface-600 text-xl"
          }, "⌘"), _createElementVNode("kbd", {
            class: "text-surface-600 text-sm"
          }, "K")], -1))]),
          _: 1
        })]),
        footer: _withCtx(() => [isDialogFooterVisible.value ? (_openBlock(), _createElementBlock("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [_cache[4] || (_cache[4] = _createElementVNode("div", {
          class: "flex flex-col gap-1 justify-center align-middle content-center"
        }, [_createElementVNode("i", {
          class: "fa-regular fa-arrow-turn-down-left px-1.5 py-1.5 bg-surface-100 text-surface-500 w-8 rounded text-sm"
        })], -1)), _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.$tf("search.commandK.toSelect")), 1)]), _createElementVNode("div", _hoisted_27, [_cache[5] || (_cache[5] = _createElementVNode("div", {
          class: "flex flex-col gap-1 justify-center align-middle content-center"
        }, [_createElementVNode("i", {
          class: "fa-regular fa-arrow-up px-1.5 py-1.5 bg-surface-100 text-surface-500 w-8 rounded text-sm"
        })], -1)), _cache[6] || (_cache[6] = _createElementVNode("div", {
          class: "flex flex-col gap-1 justify-center align-middle content-center"
        }, [_createElementVNode("i", {
          class: "fa-regular fa-arrow-down px-1.5 py-1.5 bg-surface-100 text-surface-500 w-8 rounded text-sm"
        })], -1)), _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.$tf("search.commandK.toNavigate")), 1)]), _createElementVNode("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, [_createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.$tf("search.commandK.toEscape")), 1)]), _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.$tf("search.commandK.toClose")), 1)])])) : _createCommentVNode("", true)]),
        default: _withCtx(() => [querying.value || hasAnyResults.value || query.value.length >= 3 ? (_openBlock(), _createElementBlock("div", _hoisted_1, [querying.value ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_Skeleton, {
          class: "my-2",
          width: "50%",
          height: "24px"
        }), _createVNode(_component_Skeleton, {
          class: "my-2",
          width: "100%",
          height: "12px"
        }), _createVNode(_component_Skeleton, {
          class: "my-2",
          width: "80%",
          height: "12px"
        })])) : _createCommentVNode("", true), !querying.value && !hasAnyResults.value && query.value.length >= 3 ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$tf("search.commandK.noResults")), 1)])) : _createCommentVNode("", true), hasAnyResults.value ? (_openBlock(), _createElementBlock("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(searchResults.value, category => {
          return _openBlock(), _createElementBlock("div", {
            class: "flex flex-col gap-2",
            key: category.label
          }, [_createElementVNode("div", _hoisted_6, [_createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$tf(category.label)), 1)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(category.results, result => {
            return _openBlock(), _createElementBlock("div", {
              class: "flex",
              key: result.id
            }, [_createElementVNode("div", {
              class: _normalizeClass(["w-full flex flex-row gap-5 px-[1.125rem] py-2.5 cursor-pointer bg-surface-50 hover:bg-surface-200 transition-colors duration-200 !text-surface-600 rounded-lg", {
                'bg-surface-200': isSelected(result),
                'bg-surface-100 hover:bg-surface-200': !isSelected(result)
              }]),
              onClick: $event => navigateTo(result.url)
            }, [_cache[3] || (_cache[3] = _createElementVNode("div", {
              class: "flex flex-col justify-center align-middle content-center"
            }, [_createElementVNode("i", {
              class: "fa-regular fa-hashtag text-surface-500 text-sm"
            })], -1)), _createElementVNode("div", _hoisted_9, [_createElementVNode("p", _hoisted_10, _toDisplayString(result.title), 1), _createElementVNode("p", _hoisted_11, _toDisplayString(result.description), 1)]), _createElementVNode("div", _hoisted_12, [isSelected(result) ? (_openBlock(), _createElementBlock("i", _hoisted_13)) : _createCommentVNode("", true)])], 10, _hoisted_8)]);
          }), 128))]);
        }), 128))])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), query.value.length === 0 && !querying.value ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.$tf("search.commandK.recent")), 1)]), recents.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_18, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(recents.value.slice(0, 10), recentResult => {
          return _openBlock(), _createElementBlock("div", {
            key: recentResult.id,
            class: "flex justify-between w-full text-sm hover:bg-surface-100 text-surface-900 hover:text-primary-400 p-2 rounded-md cursor-pointer"
          }, [_createElementVNode("p", {
            onClick: _withModifiers($event => selectRecentQuery(recentResult.id), ["prevent"]),
            class: "w-[90%]"
          }, _toDisplayString(recentResult.query), 9, _hoisted_19), _createElementVNode("div", _hoisted_20, [_createElementVNode("i", {
            class: "fa-regular fa-xmark cursor-pointer",
            onClick: _withModifiers($event => deleteRecent(recentResult.id), ["prevent"])
          }, null, 8, _hoisted_21)])]);
        }), 128))])) : recents.value.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_22, [_createElementVNode("p", _hoisted_23, _toDisplayString(_ctx.$tf("search.commandK.noRecentSearches")), 1)])) : _createCommentVNode("", true)])])])) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["visible", "pt"])]);
    };
  }
};